var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.22437 7.33862L6.42945 0.25611C6.72861 -0.0853699 7.21391 -0.0853699 7.51307 0.25611L8.23686 1.08229C8.5357 1.42341 8.53602 1.9759 8.23814 2.31774L3.32037 7.95708L8.23782 13.5968C8.53602 13.9386 8.53538 14.4911 8.23654 14.8322L7.51275 15.6584C7.21359 15.9999 6.72829 15.9999 6.42914 15.6584L0.22437 8.57553C-0.0747899 8.23405 -0.0747899 7.6801 0.22437 7.33862Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76343 7.33862L12.9685 0.25611C13.2677 -0.0853699 13.753 -0.0853699 14.0521 0.25611L14.7759 1.08229C15.0748 1.42341 15.0751 1.9759 14.7772 2.31774L9.85943 7.95708L14.7769 13.5968C15.0751 13.9386 15.0744 14.4911 14.7756 14.8322L14.0518 15.6584C13.7527 15.9999 13.2674 15.9999 12.9682 15.6584L6.76343 8.57553C6.46427 8.23405 6.46427 7.6801 6.76343 7.33862Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.9567831fce5f12299db7baae4c71be6c.svg";
export { ForwardRef as ReactComponent };